const LOGO_URL = "https://customer-assets.emergentagent.com/job_kerma-inventory/artifacts/0bq2bcqb_Captura%20de%20pantalla%202026-04-19%20a%20la%28s%29%203.59.23%E2%80%AFa.m..png";

export default function Logo({ size = 40, showText = true, variant = "dark" }) {
  const textColor = variant === "light" ? "text-zinc-900" : "text-zinc-100";
  return (
    <div className="flex items-center gap-3 select-none" data-testid="app-logo">
      <img
        src={LOGO_URL}
        alt="KERMA GAMES"
        style={{ width: size, height: size, objectFit: "contain" }}
        className="drop-shadow-[0_0_20px_rgba(245,166,35,0.35)]"
      />
      {showText && (
        <div className={`leading-tight ${textColor}`}>
          <div className="font-bold tracking-tight text-[15px]" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>
            KERMA GAMES
          </div>
          <div className="text-[9px] tracking-[0.28em] uppercase text-[#F5A623]">
            Inventory Ops
          </div>
        </div>
      )}
    </div>
  );
}
